
define(
	'UnlockCommerce.HomeExtension.HomeExtension'
	, [
		'Home.View.Extension'
	]
	, function (
		HomeExtensionView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');
			}
		};
	});
